import React from 'react'
import {
  IsRawSafeRoot,
  Header,
  IsRawSafeBox,
  IsRawSafeColumn,
  ImageWrapper,
  Description,
  Span,
  ButtonWrapper,
} from './IsRawSafe.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import Image from 'next/image'
import dog from '../../../../../public/assets/why-we-feed-raw/dog-waiting.webp'
import processing from '../../../../../public/assets/recipes/categories/meat-packaging.webp'
import { Stack } from 'components/Stack'
import { Button } from 'components/Button'
import Trans from 'next-translate/Trans'
import Link from 'next/link'

export const IsRawSafe = () => {
  const { t } = useTranslation()
  return (
    <IsRawSafeRoot>
      <Header as="h2" size={{ '@initial': 'h3', '@bp2': 'h1' }} align="center">
        {t('why-we-feed-raw:safety.title')}
      </Header>
      <IsRawSafeBox>
        <IsRawSafeColumn>
          <ImageWrapper>
            <Image src={dog} alt={t('why-we-feed-raw:safety.image-prep')} />
          </ImageWrapper>
          <Description>
            <Text size="body">
              <Trans
                components={{ Span: <Span /> }}
                i18nKey="why-we-feed-raw:safety.main-description.0"
              />
            </Text>
            <Text size="body">
              <Trans
                components={{ Span: <Span /> }}
                i18nKey="why-we-feed-raw:safety.main-description.1"
              />
            </Text>
            <Text size="body">
              <Trans
                components={{ Span: <Span /> }}
                i18nKey="why-we-feed-raw:safety.main-description.2"
              />
            </Text>
          </Description>
        </IsRawSafeColumn>
        <IsRawSafeColumn>
          <Description>
            <Text size="body">
              <Trans
                components={{ Span: <Span /> }}
                i18nKey="why-we-feed-raw:safety.quality-process.0"
              />
            </Text>
            <Text size="body">
              <Trans
                components={{ Span: <Span /> }}
                i18nKey="why-we-feed-raw:safety.quality-process.1"
              />
            </Text>
          </Description>
          <ImageWrapper>
            <Image src={processing} alt={t('why-we-feed-raw:safety.image-process')} />
          </ImageWrapper>
        </IsRawSafeColumn>
      </IsRawSafeBox>
      <ButtonWrapper>
        <Link passHref href="/meal-plan">
          <Button>{t('why-we-feed-raw:cta.button')}</Button>
        </Link>
      </ButtonWrapper>
    </IsRawSafeRoot>
  )
}

IsRawSafe.displayName = 'WhyWeFeedRawIsRawSafe'
